import React from 'react';
import { connect } from 'react-redux';

import {
  getLineItemSavings,
  getLineItemProcessingQuantity,
} from '../selectors';
import { changeLineItemQuantity } from '../actions';

import LineItem from '../components/sidebar/LineItem';

const mapStateToProps = (state, ownProps) => ({
  variants: state.variants,
  isMembershipOrder: state.currentOrder.membership_order,
  quantityProcessing: getLineItemProcessingQuantity(ownProps.item, state),
  discountPerItem: getLineItemSavings(ownProps.item, state),
});

const mapDispatchToProps = (dispatch, props) => ({
  handleQuantityChange: ({ quantity, lineItem }) => {
    dispatch(
      changeLineItemQuantity({
        lineItem,
        quantity,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LineItem);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/LineItem.js